import React from "react";
import { PRESETS } from "@/lib/reportPeriods";

// Shared period picker for the Reports page: preset pills + custom From/To.
// Controlled — the parent owns {range, activePreset} and passes the handlers.
export default function ReportPeriodFilter({ range, activePreset, onPreset, onCustom }) {
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-xl border border-navy/10 bg-white p-4 shadow-sm">
      <div className="flex flex-wrap gap-2">
        {PRESETS.map((p) => (
          <button
            key={p.key}
            onClick={() => onPreset(p.key)}
            data-testid={`report-preset-${p.key}`}
            className={`rounded-full px-3.5 py-1.5 text-sm font-medium transition-colors ${
              activePreset === p.key
                ? "bg-navy text-white"
                : "border border-navy/20 text-navy hover:bg-navy/5"
            }`}
          >
            {p.label}
          </button>
        ))}
      </div>
      <div className="ml-auto flex flex-wrap items-center gap-2">
        <label className="text-xs uppercase tracking-wider text-muted-foreground">From</label>
        <input
          type="date"
          value={range.from}
          max={range.to}
          onChange={(e) => onCustom("from", e.target.value)}
          data-testid="report-from"
          className="rounded-md border border-input px-2.5 py-1.5 text-sm"
        />
        <label className="text-xs uppercase tracking-wider text-muted-foreground">To</label>
        <input
          type="date"
          value={range.to}
          min={range.from}
          onChange={(e) => onCustom("to", e.target.value)}
          data-testid="report-to"
          className="rounded-md border border-input px-2.5 py-1.5 text-sm"
        />
      </div>
    </div>
  );
}
